<template>
  <div>
    <div class="my-tutor-head">
      <van-dropdown-menu>
        <van-dropdown-item v-model="yId" :options="yearList" @change="yChange" />
        <van-dropdown-item v-model="sId" :options="sessionList" @change="sChange" />
      </van-dropdown-menu>
    </div>
    <div class="my-tutor-body">
      <div v-for="item in list" :key="item.TeacherID" class="list">
        <div class="tutor-name">{{ item.TeacherName }}</div>
        <div class="tutor-times">{{ item.StartTime }}&nbsp;至&nbsp;{{ item.EndTime }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "myexam",
  data() {
    return {
      pName: "",
      pId: "",
      yId: "",
      sId: "",
      pList: [],
      list: [],
      yearList: [],
      sessionList: []
    };
  },
  created() {
    this.getSessionNodeList();
  },
  methods: {
    async getSessionNodeList() {
      //获取学年学期
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.xyMApi}/xy/Comm/GetSessionNodeList`,
        null
      );
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.yearList.push({
              IsCurrent: item.IsCurrent,
              text: item.label,
              value: item.value,
              children: item.children
            });
          });
          this.yearList.map(item => {
            if (item.IsCurrent) {
              this.yId = item.value; //当前学年
              item.children.map(child => {
                this.sessionList.push({
                  IsCurrent: child.IsCurrent,
                  text: child.label,
                  value: child.value
                });
                if (child.IsCurrent) {
                  this.sId = child.value; //当前学期
                }
              });
            }
          });
          if (this.yId !== "" && this.sId !== "") this.getProgramme();
        }
      }
    },
    async getProgramme() {
      //获取我的导师
      this.pList = [];
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/MyTeacher/GetMyTeacher`,
        {
          sessionID: this.sId
        }
      );
      if (res.success) {
        this.list = [];
        res.data.map(item => {
          this.list.push({
            TeacherName: item.TeacherName,
            StartTime: this.xy.moment(item.StartTime).format("YYYY-MM-DD"),
            EndTime: this.xy.moment(item.EndTime).format("YYYY-MM-DD")
          });
        });
      }
      this.xy.unloading();
    },
    yChange(item) {
      //切换学年
      this.sessionList = [];
      for (let i = 0, len = this.yearList.length; i < len; i++) {
        if (item === this.yearList[i].value) {
          this.yearList[i].children.map(child => {
            this.sessionList.push({
              text: child.label,
              value: child.value
            });
          });
        }
      }
      this.sId = this.sessionList[0].value;
      this.getProgramme();
    },
    sChange() {
      //切换学期
      this.getProgramme();
    }
  }
};
</script>
<style lang="less" scoped>
.my-tutor-body {
  width: 90%;
  margin: 0 auto;
  .list {
    background: #fff;
    padding: 20px;
    margin-top: 40px;
    border-radius: 8px;
    box-shadow: 0px 2px 6px 0px rgba(166, 187, 207, 0.3);
    .tutor-name {
      font-size: 28px;
      font-weight: bold;
    }
    .tutor-times {
      margin: 20px 0;
      font-size: 26px;
      color: #999;
    }
  }
}
</style>
